export const minSm = 576
export const minMd = 768
export const minLg = 992
export const minXl = 1200

export const maxContSm = 540
export const maxContMd = 720
export const maxContLg = 960
export const maxContXl = 1140